import { useTranslation } from 'react-i18next';

import type { ImageToVideoModel } from '../../hooks/useImageToVideoActions';
import SectionCard from '../common/sectionCard';

type AdjustmentsSidebarProps = {
  model: ImageToVideoModel;
};

export const AdjustmentsSidebar = (_props: AdjustmentsSidebarProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      <SectionCard title={t('adjustments')}>
        <p className="text-sm text-gray-500">{t('image-to-video-adjustments-placeholder')}</p>
      </SectionCard>
    </div>
  );
};
